import { datadogRum } from '@datadog/browser-rum';
import jwtDecode from 'jwt-decode';

import { Sentry } from '~/errorsLogging';

import { JwtUser } from './user.type';

type TrackerUserParams = {
  accessToken?: string;
};

export const setTrackerUser = ({ accessToken }: TrackerUserParams) => {
  try {
    const jwtUser: JwtUser | null = accessToken ? jwtDecode(accessToken) : null;

    if (jwtUser) {
      setSentryUser(jwtUser);
      setDatadogUser(jwtUser);
    }

    return jwtUser;
  } catch (error) {
    console.error('Error setting tracker user', error);
    return null;
  }
};

function setSentryUser(user: JwtUser) {
  try {
    Sentry.setUser({
      id: user?.sub,
      email: user?.email,
      ip_address: '{{auto}}',
    });
  } catch (error) {
    console.error('Error setting Sentry user', error);
  }
}

async function setDatadogUser(user: JwtUser) {
  try {
    datadogRum.setUser({
      id: user?.sub,
      name: user?.prefered_username,
      email: user?.email,
      roles: user?.realm_access,
      sonar: user?.sonar,
    });
  } catch (error) {
    console.error('Error setting Datadog user', error);
  }
}
